import { AcademicCapIcon, ChevronDownIcon } from "@heroicons/react/24/outline";

/**
 * One open call in a collapsible list: the name, where, the deadline and the `action` stay in
 * view; expanding shows the summary, any `extra` and the programmes a student chooses from.
 * `programmes` is [{ key, name, meta }].
 */
export default function CallListItem({ id, name, place, tag, closing, summary, extra, programmes = [], action, expanded, onToggle }) {
  const panelId = `call-${id}-programmes`;
  return (
    <article className="rounded-lg border border-slate-100 bg-white shadow-sm">
      <div className="flex flex-wrap items-center gap-3 p-4">
        <button type="button" onClick={onToggle} aria-expanded={expanded} aria-controls={panelId} className="flex min-w-0 flex-1 items-start gap-3 text-left">
          <ChevronDownIcon className={`mt-1 h-4 w-4 shrink-0 text-slate-400 transition-transform ${expanded ? "rotate-180" : ""}`} />
          <span className="min-w-0">
            <span className="flex flex-wrap items-center gap-2">
              <span className="break-words font-semibold text-slate-900">{name}</span>
              {tag}
            </span>
            <span className="mt-0.5 block text-sm text-slate-500">{place}</span>
            <span className="mt-1 block text-xs font-medium text-amber-700">
              {closing} · {programmes.length} programme{programmes.length === 1 ? "" : "s"}
            </span>
          </span>
        </button>
        {action}
      </div>

      {expanded && (
        <div id={panelId} className="flex flex-col gap-3 border-t border-slate-100 px-4 py-3">
          {summary && <p className="whitespace-pre-line text-sm text-slate-700">{summary}</p>}
          {extra}
          {programmes.length > 0 && (
            <ul className="flex flex-col divide-y divide-slate-100 rounded-md border border-slate-100">
              {programmes.map((p) => (
                <li key={p.key} className="flex items-start gap-2 px-3 py-2">
                  <AcademicCapIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
                  <div className="min-w-0">
                    <p className="text-sm font-medium text-slate-800">{p.name}</p>
                    {p.meta && <p className="text-xs text-slate-500">{p.meta}</p>}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </article>
  );
}

// Expanded rows by ID, shared by every copy of a list
export const toggleIn = (setExpanded) => (id) =>
  setExpanded((prev) => {
    const next = new Set(prev);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    return next;
  });
